/* eslint-disable node/no-unsupported-features/es-syntax */
import { useEducationStore } from "@/entities";
import { GENERAL_ROUTE_NAMES, PROFILE_ROUTE_NAMES } from "@/shared";

import { openJivo } from "@/shared/integrations/jivo";

export const GENERAL_ROUTES = [
    {
        path: "/:pathMatch(.*)*",
        name: GENERAL_ROUTE_NAMES.NOT_FOUND,
        meta: {
            title: "errors.page_not_found",
        },
        component: () => import("../ui/NotFound.vue"),
    },
    {
        path: "/tariff-extend",
        name: GENERAL_ROUTE_NAMES.BUY_TARIFF,
        meta: {
            title: "words.tariff_renewal",
        },
        component: () => import("../../payment/ui/PaymentPage.vue"),
    },
    {
        path: "/",
        name: GENERAL_ROUTE_NAMES.DEFAULT,
        redirect: { name: PROFILE_ROUTE_NAMES.PROFILE },
    },
    {
        path: "/help",
        name: "RIH_HELP",
        beforeEnter() {
            console.debug("RIH_HELP");
            window.open("https://rentinhand.ru/help", "_blank");

            return false;
        },
    },
    {
        path: "/changes",
        name: "RIH_CHANGELOG",
        beforeEnter() {
            console.debug("RIH_CHANGELOG");
            window.open("https://rentinhand.ru/whatsnew", "_blank");

            return false;
        },
    },
    {
        path: "/jivo",
        name: "RIH_JIVO",
        beforeEnter() {
            console.debug("RIH_JIVO");
            openJivo();

            return false;
        },
    },
    {
        path: "/intro",
        name: "RIH_INTRO",
        beforeEnter() {
            console.debug("RIH_INTRO");
            useEducationStore().showEducation();

            return false;
        },
    },
];
